// extracted by mini-css-extract-plugin
export var featuresTable = "FeaturesTable-module--featuresTable--62f9c";